import { useEffect, useState } from 'react';

import { useEmployersWithTasksQuery, useSidebarDataQuery } from './hooks';
import SidebarLayout from './SidebarLayout';

interface SidebarProps {
  employerId: string;
}

const Sidebar = ({ employerId }: SidebarProps) => {
  const { employers, currentEmployer, personalProfile, loadingStatus, reload } = useSidebarDataQuery(employerId);
  const { taskCounts, tasksLoadingStatus, loadEmployersWithTasks } = useEmployersWithTasksQuery();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleEscape = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      setIsMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, []);

  return (
    <SidebarLayout
      currentEmployer={currentEmployer}
      employers={employers}
      personalProfile={personalProfile}
      taskCounts={taskCounts}
      loadingStatus={loadingStatus}
      tasksLoadingStatus={tasksLoadingStatus}
      reload={reload}
      loadEmployersWithTasks={loadEmployersWithTasks}
      isMobileMenuOpen={isMobileMenuOpen}
      toggleMobileMenu={toggleMobileMenu}
    />
  );
};

export default Sidebar;
